import HttpClienteToken from '../../services/HttpClientToken';

import { UnidadProps } from '../../interfaces/catalogos/UnidadInterface';

export const Unidad = () => {

    return new Promise<UnidadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Unidad/', token)
            .then( ({ data } : { data : UnidadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerUnidades = () => {

    return new Promise<UnidadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Unidad/ObtenerUnidades', token)
            .then( ({ data } : { data : UnidadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarUnidad = ( params: UnidadProps ) => {

    return new Promise<UnidadProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Unidad/Actualizar', params, token)
            .then( ({ data } : { data : UnidadProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idUnidad: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarUnidad = ( params: UnidadProps ) => {

    return new Promise<UnidadProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Unidad/Agregar', params, token)
            .then( ({ data } : { data : UnidadProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idUnidad: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}